




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvSectionGalleryItemStoreNew from '@/store/modules/cvSectionGalleryItemNew';
import NewContainer from '@/containers/cv-section-gallery-item/new.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionGalleryItemStoreNew.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_gallery_id } = params;
  await store.dispatch(
    CvSectionGalleryItemStoreNew.GetCvSectionGallery.namespaced({
      params: { cv_id, id: cv_section_gallery_id },
    })
  );
};

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionGalleryItemStoreNew],
    };
  },
  computed: {
    ...mapGetters(['cvSectionGallery']),
  },
});
